import { Getters } from 'vuex-smart-module';
import StaffDetailState from './state';

export default class StaffDetailGetters extends Getters<StaffDetailState> {
}
